export enum FillReason {
	self,
	TE,
	hc,
	edu,
	kela,
	org,
	testing,
	other
};

export type FillReasonKeys = keyof typeof FillReason;